// extracted by mini-css-extract-plugin
export default {"cell":"rZF74REb0YsKjlOUbpID","selected":"Sc8yJytDs8FvwDIvfpmc"};